export enum Templates {
  AppointmentConfirmation2UnconfirmedSMS = 1,
  AppointmentConfirmation1ConfirmedSMS = 2,
  AppointmentConfirmation1UnconfirmedSMS = 3,
  AppointmentPreVisitSMS = 4,
  ConfirmationSMS = 5,
  Consult1SMS = 6,
  Consult2SMS = 7,
  CSREmailSubject = 8,
  CSREmailTemplate = 9,
  LabResultEmailSubject = 10,
  LabResultEmailTemplate = 11,
  AppointmentPreVisitActionLabel = 12,
  AppointmentPreVisitLegendLabel = 13,
  ConfirmationSMSButtonLabel = 14,
  Consult1SMSButtonLabel = 15,
  Consult2SMSButtonLabel = 16,
  AppointmentConfirmation2ConfirmedSMS = 17,
  AppointmentConfirmation3ConfirmedSMS = 18,
  AppointmentConfirmation3UnConfirmedSMS = 19,
  VisitCompletionEmailSubject = 20,
  VisitCompletionEmailTemplate = 21,
  CSREmailFromDisplayname = 22,
  LabResultFromDisplayname = 23,
  VisitCompletionEmailFromDisplayname = 24,
  VisitThankYou = 25,
  VetAssistantTitle = 26,
  NotOkToReceiveServices = 27,
  ChangeVisitStatusWarning = 28,
  BookingSMS = 29,
  IntakeEmailFromDisplayname = 30,
  IntakeEmailSubject = 31,
  IntakeEmailTemplate = 32,
  CancelledClinicSMS = 33,
  CancelledClinicEmailFromDisplayname = 34,
  CancelledClinicEmailSubject = 35,
  CancelledClinicEmailBody = 36,
  CancelledClinicOpsLeaderEmailFromDisplayname = 37,
  CancelledClinicOpsLeaderEmailSubject = 38,
  CancelledClinicOpsLeaderEmailBody = 39,
  AppointmentManagementVerificationEmailFromDisplayname = 40,
  AppointmentManagementVerificationEmailSubject = 41,
  AppointmentManagementVerificationEmailBody = 42,
  AppointmentManagementVerificationSMS = 43,
  PrescriptionFooter = 44,
  UnpublishedTimeFrameNotification = 45,
  ConsentReviewRequest_SMS = 46,
  IntakeVerbiageandLink_SMS = 47,
  IntakeVerbiageandLink_Email = 48,
  InvoiceEmailSubject = 49,
  InvoiceEmailDisplayname = 50,
  InvoiceEmailTemplate = 51,
  MissedAppointmentSMS = 52,
  RabiesNewLotNumberEmailFromDisplayName = 53,
  RabiesNewLotNumberEmailSubject = 54,
  RabiesNewLotNumberEmailTemplate = 55,
  RabiesNewLotNumberEmailReceivers = 56,
  WellnessAndPreventativeCareSummaryEmailFromDisplayName = 57,
  WellnessAndPreventativeCareSummaryEmailSubject = 58,
  WellnessAndPreventativeCareSummaryEmailTemplate = 59,
  HospitalHomepage = 60,
  HospitalFAQs = 64,
  EligibleForOnlineFulfillmentModal = 69,
  InvoiceMemo = 70,
}
